import $ from 'jquery';

export default class NewsPage {
	static defaultOptions = {
		yearSelector: '.js-news-page-year',
		newsSelector: '.js-news-page-item',
		activeClass: 'news-page__nav-button_state_active',
		hideItemClass: 'news-page__item_hide'
	}

	constructor(options = NewsPage.defaultOptions) {
		this.options = options;
		this.$years = $(options.yearSelector);
		this.$news = $(options.newsSelector);
		this.$window = $(window);
	}

	handleClick = e => {
		const {activeClass} = this.options;
		const $target = $(e.currentTarget);

		if ($target.hasClass(activeClass)) {
			return false;
		}

		this.$years.removeClass(activeClass);
		$target.addClass(activeClass);
	}

	handleHideNews = () => {
		const {hideItemClass} = this.options;
		const newsCount = this.$news.length;

		this.$news.removeClass(hideItemClass);

		if (newsCount % 2) {
			this.$news.last().addClass(hideItemClass);
		}
	}

	init() {
		this.$years.on('click', this.handleClick);
		this.handleHideNews();
	}
}



// WEBPACK FOOTER //
// ./app/blocks/news-page/index.js